export default __webpack_public_path__ + "static/media/icon-delete.c0713bcd.svg";